import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Export, ExportType } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getExport(id): Promise<Export> {
    return new Export(
      await this.core.services.export.getById(id, {
        // todo
        id: null,
      })
    )
  }

  async getExports(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: Export[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.export.getList(parameters, schema)
  }

  async getTypes(
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: ExportType[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.export.getTypes(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deleteExport(export: Partial<Export>): Promise<Export> {todo
  //   return this.core.services.export.dele(Export)
  // }
}
